/* VCKE V13 single-entry series relationship support.
 * A master product alone lists every member (including itself) in custom.related_models.
 * This index is generated by Shopify Liquid and fetched page by page when >250 products.
 * Collection/search de-duplication is visual only; Shopify server-side pagination/count
 * remain based on individual products. Do not claim otherwise.
 */
(() => {
  'use strict';
  const first = document.querySelector('[data-vcke-series-index]');
  if (!first) return;
  const parse = node => { try { return JSON.parse(node.textContent); } catch { return {masters:[]}; } };
  const pages = Math.max(1, Math.min(100, Number(first.dataset.vckeSeriesPages) || 1));
  const root = parse(first);
  const url = new URL(location.href);
  const load = async () => {
    const masters = [...(root.masters || [])];
    if (pages > 1) {
      const tasks = [];
      for (let page = 2; page <= pages; page++) {
        const u = new URL('/collections/all', location.origin);
        u.searchParams.set('section_id','vcke-series-index');
        u.searchParams.set('page',String(page));
        tasks.push(fetch(u.toString()).then(r => {if (!r.ok) throw new Error('Series index request failed'); return r.text();}).then(html => {
          const d = new DOMParser().parseFromString(html,'text/html');
          const s = d.querySelector('[data-vcke-series-index]');
          if (!s) throw new Error('Series index missing');
          return parse(s).masters || [];
        }));
      }
      const extra = await Promise.all(tasks);
      extra.forEach(batch => masters.push(...batch));
    }
    return masters;
  };
  load().then(masters => {
    const byHandle = new Map();
    const byId = new Map();
    for (const master of masters) {
      const models = master.models || [];
      if (!models.length) continue;
      for (const m of models) {
        const existing = byHandle.get(m.handle);
        if (existing && existing.id !== master.id) {
          console.warn('[VCKE] Conflicting model groups:',m.handle);
          continue;
        }
        byHandle.set(m.handle,master);
        byId.set(String(m.id),master);
      }
      byHandle.set(master.handle,master);
      byId.set(String(master.id),master);
    }
    // On each visible grid, show only one card for each model group. When the
    // master is not present in this Shopify page, keep the first encountered
    // member but send it to the master product for the complete selector.
    document.querySelectorAll('.collection-grid,.product-grid,.vcke-featured__scroll').forEach(grid => {
      const seen = new Set();
      grid.querySelectorAll('.product-card[data-vcke-product-handle]').forEach(card => {
        const handle = card.dataset.vckeProductHandle;
        const group = byHandle.get(handle);
        if (!group) return;
        const key = String(group.id);
        if (seen.has(key)) { card.remove(); return; }
        seen.add(key);
        card.dataset.vckeSeriesGroup = key;
        const a = card.querySelector('a[href]');
        if (a && handle !== group.handle) a.href = group.url;
        const count = group.models.length;
        if (count > 1 && !card.querySelector('.vcke-series-count')) {
          const label = document.createElement('span');
          label.className = 'vcke-series-count';
          label.textContent = `${count} models available`;
          (card.querySelector('.product-card__body') || card).append(label);
        }
      });
    });
    // Members with no metafield still get a full selector by reverse lookup.
    const mount = document.querySelector('[data-vcke-reverse-series]');
    if (mount && !document.querySelector('.vcke-series-selector')) {
      const group = byId.get(String(mount.dataset.vckeProductId));
      if (group && group.models.length > 1) {
        const label = document.createElement('label');
        label.textContent = 'Choose Model';
        const select = document.createElement('select');
        select.className = 'vcke-series-select';
        select.setAttribute('aria-label','Choose Model');
        group.models.forEach(m => {
          const option = document.createElement('option');
          option.value = m.url;
          option.textContent = (m.sku || m.title) + (m.available ? '' : ' — Sold Out');
          option.selected = String(m.id) === String(mount.dataset.vckeProductId);
          select.append(option);
        });
        select.addEventListener('change', () => {location.assign(select.value);});
        mount.classList.add('vcke-models','vcke-series-selector');
        mount.append(label,select);
      }
    }
  }).catch(err => console.warn('[VCKE] Series index not available; leaving original products visible.',err));
})();
